<div class="copyright w-100">
    <button type="button" class="no-button firstDiv" (click)="showHide()"> <i
            class="material-icons">copyright</i></button>
    <div class="secondDiv"> <span>2025 IntelliTek Health, All Rights Reserved.</span></div>
</div>